import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Col, Form } from "react-bootstrap";
import AddmemberModal from "../../modals/add-member-modal/add-member-modal";
import AddOfficeModal from "../../modals/add-office-modal/add-office-modal";
import AddBranchModal from "../../modals/add-branch-modal/add-branch-modal";
import MemberList from "./members-list/member-list";
import ResidualList from "./residual-list/residual-list";
import OfficeList from "./office-list/office-list";
import BranchList from "./branch-list/branch-list";
import PricingTemplate from "./pricing-template/pricing-template";
import EquipmentTemplate from "./equipment-template/equipment-template";
import PricingEquipmentTemplate from "./pricing-equipment-template/pricing-equipment-template";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import config from "../../../config";
import PartnerEditPage from "../../residuals/partner-edit-page";
import AddPricingTemplate from "../../modals/add-pricing-template/add-pricing-template";
import Webhooks from "./webhook/Webhooks";
import SubOrganization from "./sub-organization/sub-organization";
import OrganizationContract from "./contracts/organization-contract";
import OrganizationEquipment from "./org-equipment";

import {
    GetOrganizationById,
    ResidualFileGet,
    addOrganizationNotes,
    DeleteMember,
    GetAdminUsers,
    getOrganizationNotes,
    UpdateMember,
    deleteOrganizationNotes,
    getOfficeList,
    getZohoList,
    getDepartmentsList,
    DeleteOffice,
    getBranchesList,
    DeleteBranch,
    UserData,
    OrganisationData,
    Logout,
    getTemplateList,
    DeletePricingTemplate,
    GetEquipmentTemplate,
    GetPricingEquipmentTemplate,
    getSubOrganizations,
    getEmsOffices,
} from "../../../api";
import moment from "moment";
import AddOrganizationModal from "../../modals/add-organizations-modal/add-organizations-modal";
import Addresidualmodal from "../../modals/add-residual-modal/add-residual-modal";
import Header from "../../preapps/Header";
import AddSubOrganization from "../../modals/add-sub-organization/add-sub-organization";
import Processors from "./processors";
import arrayToObject from "../../../helpers/dataHelpers";

const EditOrganization = (props) => {
    const organization_id = props.match.params.organization_id;
    const [organization, setOrganization] = useState(null);
    const [ResidualArray, setResidualArray] = useState(null);
    const [ResidualPdfData, setResidualPdfData] = useState(null);
    const [isPcAdmin, setIsPcAdmin] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isAgent, setIsAgent] = useState(false);
    const [isResidusalView, setIsResidusalView] = useState(false);
    const [user, setUser] = useState(null);
    const [showOrganizationModal, setShowOrganizationModal] = useState(false);
    const [orgLogoReloadCount, setOrgLogoReloadCount] = useState(
        new Date().getTime(),
    );
    const [showAddResidueModal, setShowAddResidueModal] = useState(false);

    const [showAddMember, setShowAddMember] = useState(false);
    const [organizationUsers, setOrganizationUsers] = useState(null);
    const [memberCount, setMemberCount] = useState(0);
    const [showAddOffice, setShowOffice] = useState(false);
    const [showAddBranch, setShowBranch] = useState(false);
    const [selectedMember, setSelectedMember] = useState(undefined);
    const [selectedOffice, setSelectedOffice] = useState(undefined);
    const [selectedBranch, setSelectedBranch] = useState(undefined);
    const [relationShipManagers, setRelationShipManagers] = useState([]);
    const [officesList, setOfficesList] = useState([]);
    const [branchesList, setBranchesList] = useState([]);
    const [officesOptionsList, setOfficesOptionsList] = useState([]);
    const [zohoOptionsList, setZohoOptionsList] = useState([]);
    const [departmentOptionsList, setDepartmentOptionsList] = useState([]);
    const [userOptionsList, setUserOptionsList] = useState([]);
    const [branchesOptionsList, setBranchesOptionsList] = useState([]);
    const [organizationNotes, setOrganizationNotes] = useState([]);
    const [noteValue, setNoteValue] = useState("");
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [officeCount, setOfficeCount] = useState(0);
    const [branchCount, setBranchCount] = useState(0);
    const [templateCount, setTemplateCount] = useState(0);
    const [equipmentTemplateCount, setEquipmentTemplateCount] = useState(0);
    const [pricingEquipmentTemplateCount, setPricingEquipmentTemplateCount] =
        useState(0);
    const [selectedTemplate, setSelectedTemplate] = useState(undefined);
    const [showAddTemplate, setShowTemplate] = useState(undefined);
    const [templateList, setTemplateList] = useState([]);
    const [progressions, setWebhookProgressions] = useState({});
    const [webhooks, setWebhooks] = useState({});
    const [webhooksKeyVals, setWebhooksKeyVals] = useState({});
    const [subOrgs, setSubOrgs] = useState([]);
    const [showAddSubOrgModal, setShowSubOrgModal] = useState(false);
    const [emsOffices, setEmsOffices] = useState([]);

    const populateLocalArray = (CurrentYear) => {
        var ResidualFinalArray = [];
        if (ResidualFinalArray[CurrentYear] === undefined) {
            ResidualFinalArray[CurrentYear] = [];
        }
        for (var i = 1; i <= 12; i++) {
            ResidualFinalArray[CurrentYear][i] = 0;
        }
        return ResidualFinalArray;
    };

    const getOrganizationData = () => {
        var ResidualFinalArray = [];
        var ResidualFinalPDFArray = [];
        const data = { organization_id: organization_id, year: currentYear };
        GetOrganizationById(organization_id)
            .then((response) => {
                const organizationData = response;
                setOrganization(organizationData.organization);
                setOrganizationUsers(organizationData.users);
                setWebhookProgressions(organizationData.progressions);
                setWebhooks(
                    arrayToObject(
                        organizationData.organization.webhooks,
                        "type",
                    ),
                );
                setWebhooksKeyVals(organizationData.webhooksKeyValues);
                updateMembersCount(
                    organizationData.users ? organizationData.users.length : 0,
                );
                ResidualFileGet(data)
                    .then((response) => {
                        if (response.success) {
                            const residual_data = response.data;
                            if (residual_data.length == 0) {
                                ResidualFinalArray =
                                    populateLocalArray(currentYear);
                                ResidualFinalPDFArray =
                                    populateLocalArray(currentYear);
                            } else {
                                residual_data.map((item) => {
                                    if (
                                        ResidualFinalArray[item.year] ===
                                        undefined
                                    ) {
                                        ResidualFinalArray[item.year] = [];
                                    }
                                    if (
                                        ResidualFinalPDFArray[item.year] ===
                                        undefined
                                    ) {
                                        ResidualFinalPDFArray[item.year] = [];
                                    }
                                    ResidualFinalArray[item.year][item.month] =
                                        item.uploaded;
                                    ResidualFinalPDFArray[item.year][
                                        item.month
                                    ] = item.converted_file ? 1 : 0;
                                });
                            }
                            setResidualArray(ResidualFinalArray);
                            setResidualPdfData(ResidualFinalPDFArray);
                        }
                    })
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    };

    const fetchOrganizationNotes = () => {
        getOrganizationNotes(organization_id)
            .then((response) => {
                if (response.success) {
                    if (response.notes && response.notes.length > 0) {
                        const sortedDate = response.notes.sort(function (a, b) {
                            var dateA = new Date(a.created_at),
                                dateB = new Date(b.created_at);
                            return dateB - dateA;
                        });
                        setOrganizationNotes(sortedDate);
                    } else {
                        setOrganizationNotes([]);
                    }
                }
            })
            .catch((error) => console.log(error));
    };
    const setCounter = () => {
        setOrgLogoReloadCount(new Date().getTime());
        localStorage.setItem("counter", new Date().getTime());
    };
    useEffect(() => {
        GetAdminUsers()
            .then((response) => {
                if (response.success) {
                    const users = response.users;
                    setRelationShipManagers(users);
                }
            })
            .catch((error) => console.log(error));
        fetchOrganizationNotes();
        UserData()
            .then((response) => {
                let isPcAdmin =
                    response.organization_id === 1 && response.role === "admin"
                        ? true
                        : false;
                let isAdmin =
                    response.organization_id > 1 && response.role === "admin"
                        ? true
                        : false;
                let isAgent =
                    response.organization_id > 1 && response.role === "agent"
                        ? true
                        : false;

                setIsPcAdmin(isPcAdmin);
                setIsAdmin(isAdmin);
                setIsAgent(isAgent);
                setIsResidusalView(response.is_view_residual);
                setUser(response);
            })
            .catch((error) => console.log(error));
        getOfficeList(organization_id).then((response) => {
            if (response.success) {
                let OfficeOptionsList = [];
                response.offices.map((data, i) => {
                    OfficeOptionsList.push({
                        'label': data.name,
                        'value': data.id,
                    });
                });
                setOfficesOptionsList(OfficeOptionsList);
                setOfficesList(response.offices);
                updateOfficeCount(response.offices.length);
            }
        });
        GetAdminUsers().then((response) => {
            if (response.success) {
                let UsersOptionsList = [];
                response.users.map((data, i) => {
                    UsersOptionsList.push({
                        label: data.name,
                        value: data.id,
                    });
                });
                setUserOptionsList(UsersOptionsList);
            }
        });
        getDepartmentsList().then((response) => {
            let DepartmentOptionsList = [];
            response.department_list.map((data, i) => {
                DepartmentOptionsList.push({
                    label: data.name,
                    value: data.id,
                });
            });
            setDepartmentOptionsList(DepartmentOptionsList);
        });
        getZohoList().then((response) => {
            if (response.success) {
                let ZohoOptionsList = [];
                response.zoho_list.map((data, i) => {
                    ZohoOptionsList.push({
                        label: data.name,
                        value: data.id,
                    });
                });
                setZohoOptionsList(ZohoOptionsList);
            }
        });
        getTemplateList(organization_id).then((response) => {
            if (response.success) {
                setTemplateList(response.data);
                updateTemplateCount(response.data.length);
            }
        });
        getBranchesList(organization_id).then((response) => {
            if (response.success) {
                let BranchesOptionsList = [];
                response.branches.map((data, i) => {
                    BranchesOptionsList.push({
                        'label': data.name,
                        'value': data.id,
                    });
                });
                setBranchesOptionsList(BranchesOptionsList);
                setBranchesList(response.branches);
                updateBranchCount(response.branches.length);
            }
        });

        if (typeof organization_id !== "undefined") {
            getOrganizationData();
        }
        const searchTerm = {
            organization_id: organization_id,
            template_name: "",
        };
        GetEquipmentTemplateList(searchTerm);
        GetPricingEquipmentTemplateList(searchTerm);
        getSubOrgs();
    }, []);

    const deleteMember = (member_id) => {
        const data = {
            user_id: member_id,
            organization_id: organization_id,
        };
        DeleteMember(data)
            .then((response) => {
                if (response.success) {
                    setOrganizationUsers(response.users);
                    updateMembersCount(response.users.length);
                } else {
                    alert(response.message);
                }
            })
            .catch((error) => console.log(error));
    };

    const editMember = (member) => {
        setSelectedMember(member);
        setShowAddMember(true);
    };

    const deleteOffice = (office_id) => {
        const data = {
            id: office_id,
            organization_id: organization_id,
        };
        DeleteOffice(data)
            .then((response) => {
                if (response.success) {
                    setOfficesList(response.offices);
                    updateOfficeCount(response.offices.length);
                    getBranchesList(organization_id).then((response) => {
                        if (response.success) {
                            setBranchesList(response.branches);
                            updateBranchCount(response.branches.length);
                        }
                    });
                } else {
                    alert(response.message);
                }
            })
            .catch((error) => console.log(error));
    };

    const editOffice = (office) => {
        setSelectedOffice(office);
        setShowOffice(true);
    };

    const updateOfficeCount = (count) => {
        setOfficeCount(count);
    };
    const editBranch = (branch) => {
        setSelectedBranch(branch);
        setShowBranch(true);
    };
    const editTemplate = (template) => {
        setSelectedTemplate(template);
        setShowTemplate(true);
    };
    const deleteBranch = (branch) => {
        const data = {
            id: branch.id,
            office_id: branch.office_id,
            organization_id: organization_id,
        };
        DeleteBranch(data)
            .then((response) => {
                if (response.success) {
                    setBranchesList(response.branches);
                    updateBranchCount(response.branches.length);
                } else {
                    alert(response.message);
                }
            })
            .catch((error) => console.log(error));
    };

    const updateTemplateCount = (count) => {
        setTemplateCount(count);
    };
    const deleteTemplate = (template) => {
        DeletePricingTemplate(template.id)
            .then((response) => {
                if (response.success) {
                    // get updated list of templates
                    getTemplateList(organization_id).then((response) => {
                        if (response.success) {
                            setTemplateList(response.data);
                            updateTemplateCount(response.data.length);
                        }
                    });
                } else {
                    alert(response.message);
                }
            })
            .catch((error) => console.log(error));
    };
    const updateBranchCount = (count) => {
        setBranchCount(count);
    };

    const updateMemberStatus = (member, role) => {
        let tempName = member.name.split(" ");
        let firstName = "";
        let lastName = "";
        if (tempName.length > 1) {
            lastName = tempName[tempName.length - 1];
            tempName.pop();
            firstName = tempName.toString().replace(/,/g, " ");
        } else {
            firstName = tempName[0];
        }
        member["disabled"] = role;
        member["first_name"] = firstName;
        member["last_name"] = lastName !== "" ? lastName : "placeholder";
        UpdateMember(organization_id, member)
            .then((response) => {
                if (response.success) {
                    setOrganizationUsers(response.users);
                    updateMembersCount(response.users.length);
                } else {
                    alert(response.message);
                }
            })
            .catch((error) => console.log(error));
    };

    const updateMembersCount = (count) => {
        setMemberCount(count);
    };

    const handleDeleteNote = (noteId) => {
        deleteOrganizationNotes(noteId, organization_id)
            .then((response) => {
                if (response.success) {
                    if (response.notes && response.notes.length > 0) {
                        const sortedDate = response.notes.sort(function (a, b) {
                            var dateA = new Date(a.created_at),
                                dateB = new Date(b.created_at);
                            return dateB - dateA;
                        });
                        setOrganizationNotes(sortedDate);
                        setNoteValue("");
                    } else {
                        setOrganizationNotes([]);
                        setNoteValue("");
                    }
                }
            })
            .catch((error) => console.log(error));
    };

    const handleOrgDeleteNote = (noteId) => {
        confirmAlert({
            title: "Delete Note",
            message: "Are you sure you want to delete the note?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => handleDeleteNote(noteId),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    const bindOrganizationNotes = (note, index) => {
        return (
            <div key={"note" + index} className="notesfuul">
                <p>{note.content}</p>
                <div className="fulldetailsnote">
                    <div className="notesdetails">
                        <div className="notesavt">
                            <img src="/images/avatar-default.png" />
                        </div>
                        <div className="avtname">
                            <span>{note.who}</span>
                        </div>
                        <div className="avtdatetime">
                            <span>
                                {moment(note.created_at).format("LL")} |{" "}
                            </span>
                            <span>{moment(note.created_at).format("LT")}</span>
                        </div>
                    </div>
                    <span
                        onClick={(evt) => handleOrgDeleteNote(note.id)}
                        className="addresidualIMG"
                    >
                        <img src="/images/delet.svg " />
                    </span>
                </div>
            </div>
        );
    };

    const bindMainAdmin = (main_admin_id) => {
        try {
            if (main_admin_id) {
                const mainAdmin = organizationUsers
                    ? organizationUsers.find((x) => x.id === main_admin_id)
                    : undefined;
                if (mainAdmin) {
                    return (
                        <div className="main-infoedit">
                            <h2>{mainAdmin.name}</h2>
                            <p>Main admin</p>
                            <div className="edit-contact">
                                <div className="contactPH">
                                    <span>
                                        {" "}
                                        <img src="/images/call.svg" />
                                        {mainAdmin.phone_direct}
                                    </span>
                                </div>
                                <div className="contactAD">
                                    <span>
                                        {" "}
                                        <img src="/images/mail.svg" />
                                        {mainAdmin.email}
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                } else {
                    return "";
                }
            } else {
                return "";
            }
        } catch (err) {
            return "";
        }
    };
    const loginAs = (member) => {
        window.location.href = "/admin/user/switch/start/" + member.id;
    };
    const bindRelationShipManager = (primary_contact_id) => {
        if (primary_contact_id) {
            const primaryContact = relationShipManagers.find(
                (x) => x.id === primary_contact_id,
            );
            if (primaryContact) {
                return (
                    <div className="main-infoedit">
                        <h2>{primaryContact.name}</h2>
                        <p>Team Lead</p>
                        <div className="edit-contact">
                            <div className="contactPH">
                                <span>
                                    {" "}
                                    <img src="/images/call.svg" />
                                    {primaryContact.phone_direct}{" "}
                                </span>
                            </div>
                            <div className="contactAD">
                                <span>
                                    {" "}
                                    <img src="/images/mail.svg" />
                                    {primaryContact.email}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    const handleNoteChange = (evt) => {
        const note = evt.target.value;
        setNoteValue(note);
    };

    const handleAddNoteClick = () => {
        if (noteValue.trim() !== "") {
            const data = {
                stratus: true,
                content: noteValue,
            };
            addOrganizationNotes(organization_id, data)
                .then((response) => {
                    if (response.success) {
                        if (response.notes && response.notes.length > 0) {
                            const sortedDate = response.notes.sort(
                                function (a, b) {
                                    var dateA = new Date(a.created_at),
                                        dateB = new Date(b.created_at);
                                    return dateB - dateA;
                                },
                            );
                            setOrganizationNotes(sortedDate);
                            setNoteValue("");
                        } else {
                            setOrganizationNotes([]);
                            setNoteValue("");
                        }
                    }
                })
                .catch((error) => console.log(error));
        } else {
            alert("Please enter a note!");
        }
    };
    const RoleLabel = (role) => {
        let Role = {
            admin: "Admin",
            agent: "Agent",
            office_head: "Office Head",
            branch_head: "Branch Head",
        };
        return Role[role];
    };
    const logout = () => {
        Logout()
            .then((response) => {
                window.location = "/";
            })
            .catch((error) => console.log(error));
    };
    const GetEquipmentTemplateList = (searchTerm) => {
        GetEquipmentTemplate(searchTerm)
            .then((response) => {
                if (response.success === true) {
                    setEquipmentTemplateCount(response.data.length);
                } else {
                    setEquipmentTemplateCount(0);
                }
            })
            .catch((error) => console.log(error));
    };
    const GetPricingEquipmentTemplateList = (searchTerm) => {
        GetPricingEquipmentTemplate(searchTerm)
            .then((response) => {
                if (response.success === true) {
                    setPricingEquipmentTemplateCount(response.data.length);
                } else {
                    setPricingEquipmentTemplateCount(0);
                }
            })
            .catch((error) => console.log(error));
    };

    const getSubOrgs = () => {
        getSubOrganizations(organization_id)
            .then((res) => {
                let subOrgTemp = res.data.data;
                setSubOrgs(subOrgTemp);
            })
            .catch((err) => {
                console.log("error getting sub orgs");
            });

        getEmsOffices()
            .then((res) => {                
                if (res?.status) {
                    setEmsOffices(res.data);
                }
            })
            .catch((err) => {
                console.log("eeeeeee", err);
            });
    };

    const openAddSubOrgModal = (modalStatus) => {
        setShowSubOrgModal(modalStatus);
    };

    return (
        <div className="website-wrapper application-page organizationsPage ">
            {showOrganizationModal && (
                <AddOrganizationModal
                    organization_user={organizationUsers}
                    selectedOrganization={organization}
                    isPcAdmin={isPcAdmin}
                    updateOrganizations={() => {
                        getOrganizationData();
                        setShowOrganizationModal(false);
                        setCounter();
                        fetchOrganizationNotes();
                    }}
                    handleClose={() => setShowOrganizationModal(false)}
                    show={showOrganizationModal}
                />
            )}
            {showAddResidueModal && (
                <Addresidualmodal
                    selectedOrganization_id={organization_id}
                    handleClose={() => {
                        setShowAddResidueModal(false);
                    }}
                    show={showAddResidueModal}
                />
            )}
            <div className=" page-bottom-wrap edit-organization">
                {showAddMember && (
                    <AddmemberModal
                        selectedMember={selectedMember}
                        organization_id={organization_id}
                        user={user}
                        addNewMembers={(evt) => {
                            setOrganizationUsers(evt);
                            updateMembersCount(evt.length);
                            setShowAddMember(false);
                            setSelectedMember(undefined);
                        }}
                        handleClose={() => {
                            setShowAddMember(false);
                            setSelectedMember(undefined);
                        }}
                        officesList={officesOptionsList}
                        zohoList={zohoOptionsList}
                        departmentList={departmentOptionsList}
                        userList={userOptionsList}
                        branchesList={branchesOptionsList}
                        show={showAddMember}
                        isPcAdmin={isPcAdmin}
                        subOrgs={subOrgs}
                        emsOffices={emsOffices}
                    />
                )}
                {showAddOffice && (
                    <div>
                        <AddOfficeModal
                            selectedOffice={selectedOffice}
                            organization_id={organization_id}
                            user={user}
                            addNewOffice={(evt) => {
                                setOfficesList(evt);
                                updateOfficeCount(evt.length);
                                setShowOffice(false);
                                setSelectedOffice(undefined);
                            }}
                            handleClose={() => {
                                setShowOffice(false);
                                setSelectedOffice(undefined);
                            }}
                            show={showAddOffice}
                        />
                    </div>
                )}

                {showAddBranch && (
                    <div>
                        <AddBranchModal
                            selectedBranch={selectedBranch}
                            officesList={officesList}
                            user={user}
                            addNewBranch={(evt) => {
                                setBranchesList(evt);
                                updateBranchCount(evt.length);
                                setShowBranch(false);
                                setSelectedBranch(undefined);
                            }}
                            handleClose={() => {
                                setShowBranch(false);
                                setSelectedBranch(undefined);
                            }}
                            show={showAddBranch}
                            organization_id={organization_id}
                        />
                    </div>
                )}

                {showAddSubOrgModal && (
                    <AddSubOrganization
                        show={showAddSubOrgModal}
                        openAddSubOrgModal={openAddSubOrgModal}
                        organization_id={organization_id}
                        getSubOrgs={getSubOrgs}
                    />
                )}
                <div className="container-fluid">
                    <div className="row">
                        <div className={isPcAdmin ? "col-md-9" : "col-md-12"}>
                            <div className="bredcum">
                                {isPcAdmin && (
                                    <button
                                        onClick={(evt) => {
                                            props.history.push("/organization");
                                        }}
                                    >
                                        <i
                                            className="fa fa-arrow-left"
                                            aria-hidden="true"
                                        ></i>
                                        Back to organizations list
                                    </button>
                                )}
                            </div>
                            <div className="edit-org-header">
                                <div className="edit-logo">
                                    {organization && (
                                        <div className="logo-section">
                                            <span>
                                                <img
                                                    className="organisationLogo"
                                                    src={
                                                        "/img/" +
                                                        organization.whitelabel_slug +
                                                        "/logo-solid.png?" +
                                                        orgLogoReloadCount
                                                    }
                                                />
                                            </span>
                                            <h1>{organization.name}</h1>
                                        </div>
                                    )}
                                </div>
                                {(isPcAdmin || isAdmin) && (
                                    <div>
                                        <div
                                            onClick={(evt) =>
                                                setShowOrganizationModal(true)
                                            }
                                            className="edit-right"
                                        >
                                            <span>Edit</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {organization && (
                                <div className="edit-info">
                                    <div className="edit-contact">
                                        <div className="contactPH">
                                            <span>
                                                <img src="/images/aduser.png " />
                                                ORG ID {organization.id}
                                            </span>
                                        </div>
                                        <div className="contactPH">
                                            <span>
                                                {" "}
                                                <img src="/images/call.svg" />
                                                {organization.phone}
                                            </span>
                                        </div>
                                        <div className="contactAD">
                                            <span>
                                                {" "}
                                                <img src="/images/address.svg" />
                                                {organization.address}
                                            </span>
                                        </div>
                                        <div className="contactAD">
                                            <span>
                                                {" "}
                                                <img src="/images/mail.svg" />
                                                {organization.email}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {organization &&
                                organization.main_admin &&
                                bindMainAdmin(organization.main_admin)}
                            {organization &&
                                relationShipManagers &&
                                relationShipManagers.length > 0 &&
                                organization.primary_contact_id &&
                                bindRelationShipManager(
                                    organization.primary_contact_id,
                                )}

                            <div className="editTab">
                                <Tabs>
                                    {/* if Role is agent and isResidusalView checkbox is clicked
                    during adding member then it will show only residual tab */}
                                    {isAgent && isResidusalView ? (
                                        <div>
                                            <TabList>
                                                <Tab>Residuals</Tab>
                                            </TabList>

                                            <TabPanel>
                                                {ResidualArray && (
                                                    <ResidualList
                                                        organization_id={
                                                            organization_id
                                                        }
                                                        ResidualArray={
                                                            ResidualArray
                                                        }
                                                        ResidualPdfData={
                                                            ResidualPdfData
                                                        }
                                                        isPcAdmin={isPcAdmin}
                                                    />
                                                )}
                                            </TabPanel>
                                        </div>
                                    ) : (
                                        <div>
                                            <TabList>
                                                {isPcAdmin ||
                                                isResidusalView ? (
                                                    <Tab>Residuals</Tab>
                                                ) : (
                                                    <></>
                                                )}
                                                <Tab>
                                                    Members{" "}
                                                    <span>
                                                        {" "}
                                                        ( {memberCount} ){" "}
                                                    </span>
                                                </Tab>
                                                {user != null &&
                                                user.id &&
                                                config.paymentcloud
                                                    .RESIDUAL_SYSTEM &&
                                                config.paymentcloud.RESIDUAL_SYSTEM.includes(
                                                    user.id,
                                                ) ? (
                                                    <Tab>Residual Settings</Tab>
                                                ) : (
                                                    <></>
                                                )}
                                                <Tab>Webhook</Tab>
                                                {isPcAdmin ||
                                                (user?.role == "admin" &&
                                                    user?.sub_org_id ==
                                                        null) ? (
                                                    <Tab>Sub Organization</Tab>
                                                ) : (
                                                    <></>
                                                )}
                                                {isPcAdmin ? (
                                                    <Tab>Processors</Tab>
                                                ) : (
                                                    <></>
                                                )}

                                                    {isPcAdmin ? (
                                                        <>
                                                            <Tab>Equipments</Tab>
                                                            <Tab>Office</Tab>
                                                            <Tab>Branch</Tab>
                                                        </>
                                                ) : (
                                                    <></>
                                                    )}


                                            </TabList>
                                            {isPcAdmin || isResidusalView ? (
                                                <TabPanel>
                                                    <ResidualList
                                                        organization_id={
                                                            organization_id
                                                        }
                                                        ResidualArray={
                                                            ResidualArray
                                                        }
                                                        ResidualPdfData={
                                                            ResidualPdfData
                                                        }
                                                        isPcAdmin={isPcAdmin}
                                                        isAdmin={isAdmin}
                                                        isAgent={isAgent}
                                                    />
                                                </TabPanel>
                                            ) : (
                                                <></>
                                            )}
                                            <TabPanel>
                                                <MemberList
                                                    updateMemberStatus={(
                                                        member,
                                                        role,
                                                    ) =>
                                                        updateMemberStatus(
                                                            member,
                                                            role,
                                                        )
                                                    }
                                                    loginAs={(evt) =>
                                                        loginAs(evt)
                                                    }
                                                    editMember={(evt) =>
                                                        editMember(evt)
                                                    }
                                                    deleteMember={(evt) =>
                                                        deleteMember(evt)
                                                    }
                                                    showAddMemberModal={() => {
                                                        setShowAddMember(true);
                                                        setSelectedMember(
                                                            undefined,
                                                        );
                                                    }}
                                                    updateMembersCount={(evt) =>
                                                        updateMembersCount(evt)
                                                    }
                                                    organization_user={
                                                        organizationUsers
                                                    }
                                                    organizationId={
                                                        organization_id
                                                    }
                                                    RoleLabel={(role) =>
                                                        RoleLabel(role)
                                                    }
                                                    branchesList={branchesList}
                                                    officesList={officesList}
                                                    isPcAdmin={isPcAdmin}
                                                    subOrgs={subOrgs}
                                                    user={user}
                                                />
                                            </TabPanel>


                                            {user != null &&
                                            user.id &&
                                            config.paymentcloud
                                                .RESIDUAL_SYSTEM &&
                                            config.paymentcloud.RESIDUAL_SYSTEM.includes(
                                                user.id,
                                            ) ? (
                                                <TabPanel>
                                                    <PartnerEditPage
                                                        organizationId={
                                                            organization_id
                                                        }
                                                    ></PartnerEditPage>
                                                </TabPanel>
                                            ) : (
                                                <></>
                                            )}
                                            <TabPanel>
                                                <Webhooks
                                                    progressions={progressions}
                                                    organizationId={
                                                        organization_id
                                                    }
                                                    webhooks={webhooks}
                                                    webhooksKeyVals={
                                                        webhooksKeyVals
                                                    }
                                                />
                                            </TabPanel>
                                            {isPcAdmin ||
                                            (user?.role == "admin" &&
                                                user?.sub_org_id == null) ? (
                                                <TabPanel>
                                                    <SubOrganization
                                                        openAddSubOrgModal={
                                                            openAddSubOrgModal
                                                        }
                                                        subOrgs={subOrgs}
                                                    />
                                                </TabPanel>
                                            ) : (
                                                <></>
                                            )}
                                            {isPcAdmin ? (
                                                <TabPanel>
                                                    <Processors
                                                        organization_id={
                                                            organization_id
                                                        }
                                                        bankApplications={
                                                            organization?.bank_applications
                                                        }
                                                        bankAddendums={
                                                            organization?.bank_addendums
                                                        }
                                                    />
                                                </TabPanel>
                                            ) : (
                                                <></>
                                            )}

                                                {isPcAdmin ? (
                                                    <>
                                                <TabPanel>
                                                    <OrganizationEquipment
                                                        organization_id={
                                                            organization_id
                                                        }
                                                        organization_data={
                                                            organization
                                                        }
                                                    />
                                                        </TabPanel>                                        
                                                <TabPanel>
                                                    <OfficeList
                                                        editOffice={(evt) => editOffice(evt)}
                                                        deleteOffice={(evt) => deleteOffice(evt)}
                                                        showAddOfficeModal={() => {
                                                            setShowOffice(true);
                                                            setSelectedOffice(undefined);
                                                        }}
                                                        office_list={officesList}
                                                        organizationId={organization_id}
                                                        updateOfficeCount={(evt) => updateOfficeCount(evt)}
                                                        showAddOffice={showAddOffice}
                                                    />
                                                </TabPanel>
                                                <TabPanel>
                                                    <BranchList
                                                        editBranch={(evt) => editBranch(evt)}
                                                        deleteBranch={(evt) => deleteBranch(evt)}
                                                        showAddBranchModal={() => {
                                                            setShowBranch(true);
                                                            setSelectedBranch(undefined);
                                                        }}
                                                        branch_list={branchesList}
                                                        office_list={officesList}
                                                        organizationId={organization_id}
                                                        updateBranchCount={(evt) => updateBranchCount(evt)}
                                                        showAddBranch={showAddBranch}
                                                    />
                                                        </TabPanel>
                                                    </>) : <></>

                                                }
                                        </div>
                                    )}
                                </Tabs>
                            </div>
                        </div>
                        {isPcAdmin && (
                            <div className="col-md-3 over-flow-auto">
                                <OrganizationContract
                                    org_id={organization_id}
                                />
                                <div className="addNotes">
                                    <div className="notesHead">
                                        <p>
                                            Notes{" "}
                                            <span>
                                                (
                                                {organizationNotes &&
                                                organizationNotes.length > 0
                                                    ? organizationNotes.length
                                                    : 0}
                                                )
                                            </span>{" "}
                                        </p>
                                    </div>
                                    <div className="Notesedit">
                                        <Form.Row>
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <div className="input-wrap">
                                                    <textarea
                                                        placeholder="Your note"
                                                        className="add-note-input"
                                                        onChange={(evt) =>
                                                            handleNoteChange(
                                                                evt,
                                                            )
                                                        }
                                                        name="notes"
                                                        value={noteValue}
                                                    ></textarea>
                                                    <button
                                                        onClick={(evt) =>
                                                            handleAddNoteClick()
                                                        }
                                                        className="edit notessave"
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                ></Form.Control.Feedback>
                                            </Form.Group>
                                        </Form.Row>
                                        {organizationNotes &&
                                            organizationNotes.length > 0 &&
                                            organizationNotes.map(
                                                (notes, index) =>
                                                    bindOrganizationNotes(
                                                        notes,
                                                        index,
                                                    ),
                                            )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditOrganization;
